<template>
    <Head title="Ranking" />
    <AuthenticatedLayout>
        <Heading title="Ranking" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div
            class="grid modal-show fixed bg-gray-600 bg-opacity-80 top-0 left-0 items-center justify-center w-screen h-screen"
            v-if="showFilter"
        >
            <div class="grid rounded-2xl p-4 items-center bg-white w-[20.8rem]">
                <div>
                    <div class="relative flex flex-col">
                        <h1 class="font-bold text-primary text-center">
                            Filtro
                        </h1>
                        <p class="text-gray-500 font-bold pt-2 pb-4">Data</p>
                        <button
                            class="absolute top-0 right-0 font-semibold text-primary translate-y-1/4"
                            @click="showFilter = false"
                        >
                            <Icon name="Fechar" />
                        </button>

                        <a
                            v-if="showFilterPeriod"
                            href="javascript:void(0) "
                            class="absolute flex items-center top-0 left-0 text-selected text-xs"
                            :class="{ hidden: isAddClassVoltar }"
                            @click="showFilterPeriod = false"
                        >
                            <Icon
                                class="w-3 !text-selected"
                                name="SetaEsquerda"
                            />
                            Voltar
                        </a>
                    </div>
                    <div v-if="!showFilterPeriod">
                        <div>
                            <label
                                @click="showSelectYear = !showSelectYear"
                                class="w-[83px] px-3 py-2.5 bg-white border border-primary rounded-xl mb-2 cursor-pointer flex justify-between"
                            >
                                <p>{{ currentYear ? currentYear : "Ano" }}</p>
                                <Icon
                                    name="SetaDireita"
                                    :class="
                                        showSelectYear
                                            ? '-rotate-90'
                                            : 'rotate-90'
                                    "
                                />
                            </label>
                            <div
                                class="w-[83px] bg-white border border-primary rounded-3xl text-center absolute"
                                v-if="showSelectYear"
                            >
                                <div
                                    class="border-primary px-3 py-2.5 hover:bg-primary hover:text-white cursor-pointer"
                                    :class="
                                        yearList.length == 0
                                            ? 'hover:rounded-full'
                                            : 'border-b hover:rounded-t-2xl'
                                    "
                                    @click="
                                        currentYear = '2022';
                                        this.showSelectYear = false;
                                    "
                                >
                                    2022
                                </div>
                                <div
                                    :class="
                                        year == yearList[yearList.length - 1]
                                            ? '!border-b-0 hover:rounded-b-2xl'
                                            : ''
                                    "
                                    class="border-b border-primary px-3 py-2.5 hover:bg-primary hover:text-white cursor-pointer"
                                    v-for="(year, key) in yearList"
                                    :key="key"
                                    @click="
                                        currentYear = year;
                                        this.showSelectYear = false;
                                    "
                                >
                                    {{ year }}
                                </div>
                            </div>
                        </div>
                        <ul class="flex flex-wrap gap-4 mt-4">
                            <li
                                v-for="(filter, key) in [1, 2, 3, 4]"
                                :key="key"
                            >
                                <a
                                    @click="currentTrimestre = filter"
                                    class="border p-2 font-bold text-xs rounded-2xl table w-full text-center text-primary border-primary hover:bg-secondary hover:border-transparent cursor-pointer"
                                    :class="
                                        currentTrimestre == filter
                                            ? 'bg-secondary border-transparent'
                                            : ''
                                    "
                                    >{{ filter }}º Tri</a
                                >
                            </li>

                            <li>
                                <a
                                    href="javascript:void(0)"
                                    class="border p-2 font-bold text-xs rounded-2xl table w-full text-center text-primary hover:bg-secondary hover:border-transparent cursor-pointer"
                                    @click="
                                        showFilterPeriod = true;
                                        resetDataFilter();
                                    "
                                    >Selecionar Periodo</a
                                >
                            </li>
                        </ul>
                        <ul class="grid grid-cols-2 gap-7 mt-4">
                            <li>
                                <a
                                    href=""
                                    class="grid font-bold text-primary text-center p-2 border-primary border rounded-2xl mb-2 hover:bg-gray-300"
                                >
                                    Limpar Filtros
                                </a>
                            </li>

                            <li>
                                <button
                                    @click.prevent="sendFixedFilter"
                                    class="grid font-bold text-center p-2 border-primary border rounded-2xl mb-2 bg-primary text-white hover:bg--black hover:border-black"
                                >
                                    Aplicar Filtros
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div v-if="showFilterPeriod">
                        <ul class="grid gap-5 pt-1 grid-flow-col">
                            <li>
                                <label class="mb-1 mr-5 flex font-semibold">
                                    De:
                                </label>
                                <input
                                    @click="setInput('initialData')"
                                    v-model="initialData.data"
                                    @keyup="formatDate"
                                    type="text"
                                    placeholder="DD/MM/AAAA"
                                    class="form-input border rounded-2xl w-full focus:border-[#FFD480] disabled:opacity-50 form-textarea bg-gray-100 border-gray-300"
                                />
                            </li>

                            <li>
                                <label class="mb-1 mr-5 flex font-semibold">
                                    Até:
                                </label>
                                <input
                                    @click="setInput('finalData')"
                                    v-model="finalData.data"
                                    @keyup="formatDate"
                                    type="text"
                                    placeholder="DD/MM/AAAA"
                                    class="form-input border rounded-2xl w-full focus:border-[#FFD480] disabled:opacity-50 form-textarea bg-gray-100 border-300"
                                />
                            </li>
                        </ul>

                        <div class="calendar bg-gray-100 p-4 mt-8 rounded-2xl">
                            <div
                                class="header grid grid-cols-3 justify-items-center"
                            >
                                <button
                                    @click="prev"
                                    class="font-bold text-primary text-center"
                                >
                                    &lt;
                                </button>
                                <span
                                    class="font-bold text-primary text-center"
                                    >{{ title }}</span
                                >
                                <button
                                    @click="next"
                                    class="font-bold text-primary text-center"
                                >
                                    &gt;
                                </button>
                            </div>

                            <div
                                class="week grid grid-flow-col justify-items-center pt-2 pb-2 text-gray-400"
                            >
                                <div class="day text-xs uppercase">Dom</div>
                                <div class="day text-xs uppercase">Seg</div>
                                <div class="day text-xs uppercase">Ter</div>
                                <div class="day text-xs uppercase">Qua</div>
                                <div class="day text-xs uppercase">Qui</div>
                                <div class="day text-xs uppercase">Sex</div>
                                <div class="day text-xs uppercase">Sab</div>
                            </div>

                            <div
                                class="week grid grid-cols-auto-calendar justify-items-center h-8 items-center text-sm"
                                v-for="(week, key) in weeks"
                                :key="key"
                            >
                                <!-- :class="day == '0' ? 'hide' : ''" -->
                                <div
                                    class="day selectable g cursor-pointer hover:bg-primary hover:text-white rounded-full p-2 py-1.5 min-w-[32px] text-center"
                                    :class="{ hide: isZero(day) }"
                                    v-for="(day, key) in week"
                                    :key="key"
                                    @click="setData(day, month, year, $event)"
                                >
                                    {{ day }}
                                </div>
                            </div>
                        </div>

                        <div class="grid justify-items-center mt-8">
                            <a
                                @click="sendSpecificFilter()"
                                href="javascript:void(0)"
                                class="font-semibold grid p-4 leading-normal bg-primary text-white rounded-2xl hover:bg-black hover:border-black"
                                >Selecionar Datas</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="component-background-desktop component-background-mobile px-4 pb-4"
        >
            <section class="xl:px-[15.5vw] pt-8 sm:pt-2 flex">
                <div class="max-w-[607px] w-full">
                    <p class="text-sm">Veja o ranking atualizado.</p>
                    <a
                        title="Filtrar"
                        class="border border-primary rounded-3xl text-primary p-2 flex items-center my-6 w-[5rem] text-right justify-between text-sm bg-white cursor-pointer"
                        @click="showFilter = true"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14.23"
                            height="13.038"
                            viewBox="0 0 14.23 13.038"
                        >
                            <g
                                id="Grupo_10972"
                                data-name="Grupo 10972"
                                transform="translate(-2.385 -2.981)"
                            >
                                <path
                                    id="Caminho_10267"
                                    data-name="Caminho 10267"
                                    d="M77.941,81.526H69.462a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113h1.323a1.749,1.749,0,0,0,3.315,0h8.478a.557.557,0,1,0,0-1.113ZM67.8,82.719a.636.636,0,1,1,.636-.636A.637.637,0,0,1,67.8,82.719Z"
                                    transform="translate(-61.882 -77.353)"
                                    fill="#081D38"
                                />
                                <path
                                    id="Caminho_10268"
                                    data-name="Caminho 10268"
                                    d="M77.941,210.059H76.617a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113H73.3a1.749,1.749,0,0,0,3.316,0h1.323a.557.557,0,1,0,0-1.113Zm-2.981,1.192a.636.636,0,1,1,.636-.636A.637.637,0,0,1,74.959,211.252Z"
                                    transform="translate(-61.882 -201.116)"
                                    fill="#081D38"
                                />
                                <path
                                    id="Caminho_10269"
                                    data-name="Caminho 10269"
                                    d="M77.941,338.592H71.847a1.749,1.749,0,0,0-3.315,0H64.824a.557.557,0,0,0,0,1.113h3.708a1.749,1.749,0,0,0,3.315,0h6.093a.557.557,0,1,0,0-1.113Zm-7.751,1.192a.636.636,0,1,1,.636-.636A.637.637,0,0,1,70.19,339.785Z"
                                    transform="translate(-61.882 -324.879)"
                                    fill="#081D38"
                                />
                            </g>
                        </svg>
                        Filtrar
                    </a>
                    <section>
                        <h1 class="text-xl text-primary font-black mb-4">
                            Ranking - Faturamento
                        </h1>
                        <div
                            class="bg-white rounded-2xl border-primary border p-4"
                        >
                            <div class="flex p-4 flex-col">
                                <section class="bg-gray-50 rounded-3xl p-4">
                                    <div
                                        class="bg-primary text-white rounded-full grid grid-cols-ranking-participants-template py-[5px] px-3 mb-5"
                                    >
                                        <p>1º lugar</p>
                                        <p class="text-center">João</p>
                                        <p class="ml-10">1325</p>
                                    </div>
                                    <div
                                        class="text-black font-bold rounded px-4 grid grid-cols-ranking-participants-template border border-transparent"
                                    >
                                        <p
                                            class="border-r border-[#BBB5B5] flex items-center gap-x-2 pb-1"
                                        >
                                            Posição
                                        </p>
                                        <p
                                            class="text-center border-r border-[#BBB5B5] flex items-center justify-center gap-x-2"
                                        >
                                            RCA
                                        </p>
                                        <p
                                            class="flex items-center ml-10 gap-x-2"
                                        >
                                            Pontos
                                        </p>
                                    </div>
                                    <div
                                        v-for="(participant, key) in ranking"
                                        :key="key"
                                        class="rounded-xl px-4 grid grid-cols-ranking-participants-template grid-cols-ranking-participants grid-cols-ranking-participants"
                                    >
                                        <p
                                            class="border-r border-[#BBB5B5] flex gap-x-1 sm:justify-center py-1.5"
                                        >
                                            {{ participant.position }}º<span
                                                class="sm:hidden"
                                                >lugar</span
                                            >
                                        </p>
                                        <p
                                            class="border-r border-[#BBB5B5] flex items-center justify-center"
                                        >
                                            {{ participant.pdv.name }}
                                        </p>
                                        <p class="flex items-center ml-10">
                                            99
                                        </p>
                                    </div>
                                </section>
                            </div>
                            <p class="text-[10px]">
                                Última atualização: 22/03/2021 às 15h43
                            </p>
                        </div>
                    </section>

                    <section>
                        <h1 class="text-xl text-primary font-black mb-4 mt-8">
                            Ranking - Cobertura
                        </h1>
                        <div
                            class="bg-white rounded-2xl border-primary border p-4"
                        >
                            <div class="flex p-4 flex-col">
                                <section class="bg-gray-50 rounded-3xl p-4">
                                    <div
                                        class="bg-primary text-white rounded-full grid grid-cols-ranking-participants-template py-[5px] px-3 mb-5"
                                    >
                                        <p>1º lugar</p>
                                        <p class="text-center">João</p>
                                        <p class="ml-10">1325</p>
                                    </div>
                                    <div
                                        class="text-black font-bold rounded px-4 grid grid-cols-ranking-participants-template border border-transparent"
                                    >
                                        <p
                                            class="border-r border-[#BBB5B5] flex items-center gap-x-2 pb-1"
                                        >
                                            Posição
                                        </p>
                                        <p
                                            class="text-center border-r border-[#BBB5B5] flex items-center justify-center gap-x-2"
                                        >
                                            RCA
                                        </p>
                                        <p
                                            class="flex items-center ml-10 gap-x-2"
                                        >
                                            Pontos
                                        </p>
                                    </div>
                                    <div
                                        v-for="(participant, key) in ranking2"
                                        :key="key"
                                        class="rounded-xl px-4 grid grid-cols-ranking-participants-template grid-cols-ranking-participants grid-cols-ranking-participants"
                                    >
                                        <p
                                            class="border-r border-[#BBB5B5] flex gap-x-1 sm:justify-center py-1.5"
                                        >
                                            {{ participant.position }}º<span
                                                class="sm:hidden"
                                                >lugar</span
                                            >
                                        </p>
                                        <p
                                            class="border-r border-[#BBB5B5] flex items-center justify-center"
                                        >
                                            {{ participant.pdv.name }}
                                        </p>
                                        <p class="flex items-center ml-10">
                                            99
                                        </p>
                                    </div>
                                </section>
                            </div>
                            <p class="text-[10px]">
                                Última atualização: 22/03/2021 às 15h43
                            </p>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import { formatDate } from "@/Helpers/masks";
import Input from "@/Components/UI/Form/Select.vue";

const DATE = new Date();
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
];
const daysInYearMonth = (y, m) => new Date(y, m + 1, 0).getDate();

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
    },
    props: {
        ranking: Object,
        ranking2: Object,
    },
    data() {
        return {
            showFilter: false,
            showFilterPeriod: false,
            showSelectYear: false,
            currentYear: "",
            month: 0,
            year: 0,
            days: [],
            weeks: [],
            currentTrimestre: "",
            filterLessDay: "",
            initialData: {
                data: "",
                elSelected: "",
            },
            finalData: {
                data: "",
                elSelected: "",
            },
            currentList: this.ranking,
            propertyFilter: "",
        };
    },
    computed: {
        list: function () {
            return this.filterByProperty(this.ranking, this.propertyFilter);
        },
        yearList: function () {
            let date = new Date();
            let dif = 2022 - date.getFullYear();
            let arrayYears = [];

            for (let i = 1; i < dif; i++) {
                arrayYears.push(2022 + i);
            }
            return arrayYears;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        filterByProperty(array, property) {
            let arrayC = Object.create(array);
            if (property == "nameHigher") {
                return arrayC.sort(function (a, b) {
                    if (a.name < b.name) {
                        return 1;
                    }
                    if (a.name > b.name) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "nameLower") {
                return arrayC.sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            if (property == "positivationHigher") {
                return arrayC.sort(function (a, b) {
                    if (a.positivation < b.positivation) {
                        return 1;
                    }
                    if (a.positivation > b.positivation) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "positivationLower") {
                return arrayC.sort(function (a, b) {
                    if (a.positivation < b.positivation) {
                        return -1;
                    }
                    if (a.positivation > b.positivation) {
                        return 1;
                    }
                    return 0;
                });
            }
            if (property == "idealHigher") {
                return arrayC.sort(function (a, b) {
                    if (a.ideal < b.ideal) {
                        return 1;
                    }
                    if (a.ideal > b.ideal) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "idealLower") {
                return arrayC.sort(function (a, b) {
                    if (a.ideal < b.ideal) {
                        return -1;
                    }
                    if (a.ideal > b.ideal) {
                        return 1;
                    }
                    return 0;
                });
            }
            return arrayC;
        },
        setPropertyName() {
            this.propertyFilter == "nameHigher"
                ? (this.propertyFilter = "nameLower")
                : (this.propertyFilter = "nameHigher");
        },
        setPropertyPositivation() {
            this.propertyFilter == "positivationHigher"
                ? (this.propertyFilter = "positivationLower")
                : (this.propertyFilter = "positivationHigher");
        },
        setPropertyIdeal() {
            this.propertyFilter == "idealHigher"
                ? (this.propertyFilter = "idealLower")
                : (this.propertyFilter = "idealHigher");
        },

        isZero(value) {
            if (value == 0) {
                return true;
            }
        },
        getData(day, month, year) {
            if (day < 10) {
                day = `0${day.toString()}`;
            }
            if (month + 1 < 10) {
                month = `0${(month + 1).toString()}`;
            } else {
                month = month + 1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input) {
            this.currentInput = input;
            console.log(this.currentInput);
        },

        setData(day, month, year, el) {
            let data = this.formatData(this.getData(day, month, year));

            if (this.currentInput == "initialData") {
                if (this.initialData.elSelected) {
                    this.initialData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.initialData.elSelected = el.target;
                this.initialData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.initialData.data = data;
            }
            if (this.currentInput == "finalData") {
                if (this.finalData.elSelected) {
                    this.finalData.elSelected.classList.remove("bg-primary");
                    this.finalData.elSelected.classList.remove("text-white");
                }
                this.finalData.elSelected = el.target;
                this.finalData.elSelected.classList.add("bg-primary");
                this.finalData.elSelected.classList.add("text-white");

                this.finalData.data = data;
            }
        },

        formatData(data) {
            let value = data;

            value = value.replace(/\D/g, "");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");

            value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

            return value.substr(0, 10);
        },

        next() {
            this.update(new Date(this.year, this.month + 1, 1));
        },
        prev() {
            this.update(new Date(this.year, this.month - 1, 1));
        },
        daysInMonth() {
            return daysInYearMonth(this.year, this.month);
        },
        monthStartsOn() {
            return new Date(this.year, this.month, 1).getDay();
        },
        setTitle() {
            this.title = `${MONTHS[this.month]} ${this.year}`;
        },
        update(date) {
            if (date) {
                this.month = date.getMonth();
                this.year = date.getFullYear();
                this.day = date.getDate();
            }
            this.setTitle();
            this.setDays();
            this.setWeeks();
        },
        setDays() {
            let preDays =
                this.monthStartsOn() > 0
                    ? Array(this.monthStartsOn()).fill(0)
                    : [];
            const rawDays = [...Array(this.daysInMonth()).keys()];
            this.days = [...preDays, ...rawDays.map((item) => item + 1)];
        },
        setWeeks() {
            let n = 0;
            this.weeks = [];

            while (n < this.days.length) {
                let week = [
                    ...this.days.slice(n, (n += 7)),
                    ...Array(7).fill(0),
                ].slice(0, 7);
                this.weeks.push(week);
            }
        },
        showEvents(day) {
            alert(day);
        },
        init() {
            this.update(DATE);
        },
        setFilterValueLessDays(days) {
            let dateOffset = 24 * 60 * 60 * 1000 * days;
            let dataAtual = new Date();
            this.filterLessDay = days;

            let initialDate = new Date(dataAtual.getTime() - dateOffset);

            let initialDateFormated = this.formatFilterDate(initialDate);
            let currentDateFormated = this.formatFilterDate(dataAtual);
            ("");

            this.initialData.data = initialDateFormated;
            this.finalData.data = currentDateFormated;
            // this.filterTransactions(initialDateFormated, currentDateFormated)
            // console.log(initialDateFormated, currentDateFormated);
        },
        sendFixedFilter() {
            let trimestre = this.currentTrimestre;

            let final = new Date(this.currentYear, 3 * trimestre, 0);

            this.initialData.data = `01/01/${this.currentYear}`;
            this.finalData.data = `${final.getDate()}/${
                final.getMonth() + 1
            }/${final.getFullYear()}`;

            this.sendSpecificFilter();
        },
        formatFilterDate(data) {
            let dia = data.getDate();
            let mes = data.getMonth();
            let ano = data.getFullYear();

            // return `${ano}-${mes+1}-${dia}`
            return `${dia}/${mes + 1}/${ano}`;
        },
        filterTransactions(dataInicial, dataFinal) {
            this.$inertia.post(
                "performance",
                {
                    dataInicial: dataInicial,
                    dataFinal: dataFinal,
                },
                {
                    onSuccess: (this.showFilter = false),
                }
            );
        },
        checarData(data) {
            return data instanceof Date && !isNaN(data);
        },
        sendSpecificFilter() {
            let initialArrayData = this.initialData.data.split("/");
            let objectInitialData = new Date(
                initialArrayData[2],
                initialArrayData[1] - 1,
                initialArrayData[0]
            );

            let finalArrayData = this.finalData.data.split("/");
            let objectFinalData = new Date(
                finalArrayData[2],
                finalArrayData[1] - 1,
                finalArrayData[0]
            );

            if (
                this.checarData(objectInitialData) &&
                this.checarData(objectFinalData)
            ) {
                let initialDateFormated =
                    this.formatFilterDate(objectInitialData);
                let finalDataFormated = this.formatFilterDate(objectFinalData);

                this.filterTransactions(initialDateFormated, finalDataFormated);
            }
        },
        resetDataFilter() {
            this.initialData.data = "";
            this.finalData.data = "";
            this.filterLessDay = "";
        },
        formatDate,
    },
};
</script>
<style scoped>
.grid-cols-ranking-participants:nth-child(2n + 1) {
    background-color: #dbdbdb;
}
.grid-cols-ranking-participants-template {
    grid-template-columns: 1fr 1fr 2fr;
}
</style>
